/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CoverageRequest
 */
export interface CoverageRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof CoverageRequest
     */
    generatorKeys: Array<string>;
}

/**
 * Check if a given object implements the CoverageRequest interface.
 */
export function instanceOfCoverageRequest(value: object): value is CoverageRequest {
    if (!('generatorKeys' in value) || value['generatorKeys'] === undefined) return false;
    return true;
}

export function CoverageRequestFromJSON(json: any): CoverageRequest {
    return CoverageRequestFromJSONTyped(json, false);
}

export function CoverageRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CoverageRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'generatorKeys': json['generatorKeys'],
    };
}

export function CoverageRequestToJSON(json: any): CoverageRequest {
    return CoverageRequestToJSONTyped(json, false);
}

export function CoverageRequestToJSONTyped(value?: CoverageRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'generatorKeys': value['generatorKeys'],
    };
}

